<script>

	import { displayLang, agenda } from '../lib/stores.js';

	export let details = undefined;
	export let locationText = undefined;

	let w;

</script>

<style>
	p.location {
		margin-top: 0.2rem;
		color: var(--blend-80);
		font-size: 0.6875rem;
	}
	.location svg {
		width: 0.6rem;
		margin-right: 0.1rem;
		position: relative;
		top: 0.1rem;
	}
</style>

{#if locationText}
	<p class="location" bind:clientWidth={w} class:wide={w > 150} class:superwide={w > 250}>
		<svg viewBox="0 0 40 52"><path d="m20 4c4.9 0 9.03 1.72 11.93 4.98 2.58 2.9 4.06 6.94 4.06 11.09 0 6.89-5 13.82-10.31 21.17-1.37 1.9-2.79 3.86-4.14 5.86-.36.54-.94.87-1.51.89-.62-.03-1.21-.36-1.57-.89-1.35-2-2.77-3.96-4.16-5.88-5.29-7.34-10.3-14.27-10.3-21.16 0-4.15 1.48-8.19 4.06-11.09 2.9-3.26 7.02-4.98 11.93-4.98m0-4c-6.07.01-11.23 2.2-14.91 6.33-3.22 3.63-5.07 8.64-5.07 13.76 0 8.18 5.37 15.61 11.05 23.49 1.36 1.88 2.76 3.83 4.09 5.78 1.1 1.62 2.91 2.61 4.85 2.64h.05c1.91-.04 3.71-1.03 4.8-2.64 1.33-1.96 2.73-3.91 4.09-5.79 5.68-7.87 11.05-15.31 11.05-23.49 0-5.12-1.85-10.13-5.07-13.75-3.68-4.13-8.84-6.32-14.92-6.32z"/><circle cx="19.74" cy="18.57" r="5.38"/></svg>
		<span>{locationText}</span>
	</p>
{:else}
	{#each $agenda.locations as o}
		{#if o.ref == details}
			<p class="location" bind:clientWidth={w} class:wide={w > 150} class:superwide={w > 250}>
				<svg viewBox="0 0 40 52"><path d="m20 4c4.9 0 9.03 1.72 11.93 4.98 2.58 2.9 4.06 6.94 4.06 11.09 0 6.89-5 13.82-10.31 21.17-1.37 1.9-2.79 3.86-4.14 5.86-.36.54-.94.87-1.51.89-.62-.03-1.21-.36-1.57-.89-1.35-2-2.77-3.96-4.16-5.88-5.29-7.34-10.3-14.27-10.3-21.16 0-4.15 1.48-8.19 4.06-11.09 2.9-3.26 7.02-4.98 11.93-4.98m0-4c-6.07.01-11.23 2.2-14.91 6.33-3.22 3.63-5.07 8.64-5.07 13.76 0 8.18 5.37 15.61 11.05 23.49 1.36 1.88 2.76 3.83 4.09 5.78 1.1 1.62 2.91 2.61 4.85 2.64h.05c1.91-.04 3.71-1.03 4.8-2.64 1.33-1.96 2.73-3.91 4.09-5.79 5.68-7.87 11.05-15.31 11.05-23.49 0-5.12-1.85-10.13-5.07-13.75-3.68-4.13-8.84-6.32-14.92-6.32z"/><circle cx="19.74" cy="18.57" r="5.38"/></svg>
				<span>{o.name[$displayLang]}</span>
			</p>
		{/if}
	{/each}
{/if}